import { render, staticRenderFns } from "./ComplianceTableDashboard.vue?vue&type=template&id=5d9a7833"
import script from "./ComplianceTableDashboard.vue?vue&type=script&lang=js"
export * from "./ComplianceTableDashboard.vue?vue&type=script&lang=js"
import style0 from "./ComplianceTableDashboard.vue?vue&type=style&index=0&id=5d9a7833&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports